import { IQuestions } from 'types'

export function validateExpertise(expertise: any, rules: IQuestions['expertise']['rules']): boolean {
  let error = false

  if (!expertise.title) {
    error = true
  }

  if (!expertise.tags || !expertise.tags.length) {
    error = true
  }
  expertise.tags.forEach((tag: any) => {
    if (!tag.title) {
      error = true
    } else if (!tag.level) {
      error = true
    } else if (tag.title.length < rules?.item?.tags?.item?.title?.minLength) {
      error = true
    }
  })

  return error
}

export const validateAllExpertise = (
  allExpertise: any[],
  rules: IQuestions['expertise']['rules'],
  skipItems?: number[]
) => {
  allExpertise.forEach((expertise: any, index: number) => {
    if (!skipItems || !skipItems.length || !skipItems.includes(index)) {
      validateExpertise(expertise, rules)
    }
  })
}
